import React from "react";
import ApiService from "../../../Services/ApiService";
import AlertService from "../../../Services/AlertService";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import PlacementSection from "../placement/placementSection.js";
import queryString from "query-string";


class Placement extends React.Component {
    state = {
        client_id: '',
        campaign_id: '',
        client_name: '',
        categories: [],
        selectedCategories: [],
        audience_network: 0,
        campaign: null
    };

    componentDidMount() {

        let params = queryString.parse(this.props.location.search);

        if (params) {
            let clientId = params.client_id;
            let campaignId = params.campaign_id;

            ApiService.get('/api/campaigns/fetch?campaign_id=' + campaignId)
                .then(response => {
                    let campaign = response.data.Campaign;
                    if (campaign) {
                        this.setState({...this.state,
                                campaign_id: campaignId,
                                client_id: clientId,
                                client_name: campaign.client_name,
                                selectedCategories: campaign.categories,
                                audience_network: campaign.audience_network,
                                campaign: campaign
                            },
                            () =>  {
                            this.setCategoriesFormDisplay();
                            this.fetchAudienceCategories(clientId);
                        })
                    }
                });
        }
    }

    fetchAudienceCategories(clientId){
        ApiService.get("/api/linkedin/fetch-audience-categories?client_id=" + clientId)
            .then(response => {
                this.setState({...this.state,
                    categories: response.data.categories
                })
            });
    }

    handlePlacementChange = (title, placements) => {
        let selected = this.state.selectedCategories;
        selected[title] = placements;

        this.setState({...this.state, selectedCategories: selected})
    }

    savePlacements = () => {

        let allSelectedCategories = [];
        for (const key in this.state.selectedCategories) {
            allSelectedCategories.push(this.state.selectedCategories[key]);
        }

        allSelectedCategories = allSelectedCategories.flat(1);

        let campaign = this.state.campaign;
        campaign['categories'] = allSelectedCategories;
        campaign['audience_network'] = this.state.audience_network;

        ApiService.post('/api/campaigns/update', this.state.campaign)
            .then(response => {
                if (response.data.Success) {
                    AlertService.success('Campaign saved successfully');
                } else {
                    AlertService.error('Oops! There was an error saving the Campaign');
                }
            })
            .catch(error => {
                AlertService.error('Oops! There was an error saving the Campaign');
            });
    }

    toggleAudienceNetwork = () => {

        let enableAudienceNetwork = !this.state.audience_network;

        enableAudienceNetwork = enableAudienceNetwork ? 1 : 0;

        this.setState({...this.state, audience_network: enableAudienceNetwork}, () => {
            this.setCategoriesFormDisplay();
        })
    }

    setCategoriesFormDisplay = () => {
        let enableAudienceNetwork = this.state.audience_network;

        enableAudienceNetwork = enableAudienceNetwork ? 1 : 0;

        if (enableAudienceNetwork) {
            document.getElementById('categories_form').style.display = 'block';
        } else {
            document.getElementById('categories_form').style.display = 'none';
        }
    }



    render() {

        var selectedSections = [];
        var sections = [];

        for (var key in this.state.categories) {
            let sectionTitle = key;
            let data = this.state.categories[key];
            let categories = [];

            for (let i = 0; i < data.length; i++) {
                let categoryID = data[i].ID;
                let categoryName = data[i].Name;
                let category = {value: categoryID, label: categoryName};
                categories.push(category);
            }

            let selectedCategories = this.state.selectedCategories.hasOwnProperty(key) ? this.state.selectedCategories[key] : [];

            sections.push(<PlacementSection key={sectionTitle} title={sectionTitle} categories={categories}
                                            onPlacementChange={this.handlePlacementChange} selectedCategories={selectedCategories}/>);
        }

        for (var key in this.state.selectedCategories) {
            let sectionTitle = key;
            let categories = this.state.selectedCategories[key].join(", ");
            selectedSections.push(
                <div key={key}>
                    <div>
                        <strong>{sectionTitle}</strong>
                        <div>{categories}</div><
                        /div>
                        <div className="space-between"></div>
                    </div>);
                    }

                    return(<div className="page-main">
                    <div className="form-container">


                        <div className="placement-form">
                            <div>
                                <strong>LinkedIn Audience Network</strong>
                                <p className="form-label-details"> Reach up to 25% more of your target audience by running
                                    ads on LinkedIn and LinkedIn partner apps and websites.</p>

                                <input  type="checkbox" className="checkbox-field" name="audience_network" checked={this.state.audience_network} onChange={() => this.toggleAudienceNetwork()} />
                                <span className="checkbox-label">Enable the LinkedIn Audience Network</span>
                            </div>

                            <div className="space-between"></div>
                            <div id="categories_form" style={{display: 'none'}}>
                                <div className="selected-categories">
                                    <h3>Exclude categories from the LinkedIn Audience Network.</h3>
                                    {selectedSections}
                                </div>
                                {sections}
                            </div>
                        </div>

                        <hr width="1"></hr>
                        <div className="form-submit">
                            <button onClick={this.savePlacements}>Save</button>
                            <button type="button" className="outline"
                                    onClick = {() => {this.props.history.push("/campaigns?client_id="+ this.state.client_id + "&client_name=" + this.state.client_name)}}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
                    )
                    }


}

export default Placement